module.exports = __webpack_public_path__ + "static/img/kanban08.d34a571d.png";